<app-snapshot [settings]="settings"
      [entityConfig]="entityConfig"
      [snapshotRequestTracker$]="snapshotRequestTracker$"
      [accountPermissions]="accountPermissions"
      [availableMerchants]="userMerchants"
      [usersSelectedMerchants]="usersSelectedMerchants"
      [isUserRoot]="isUserRoot$ | async"
      [dashboard]="dashboard"></app-snapshot>
